var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.extras = $.extend({}, site.extras, {
	initForm: function () {
		site.extras.genius();

		$('#genius').change(function () {
			site.extras.genius();
		});
	},

	genius: function () {
		var $genius = $('#genius');
		if ($genius.attr('checked') === 'checked') {
			$('#lyricist').attr('value', '').prop('disabled', 'disabled');
		} else {
			$('#lyricist').removeAttr('disabled');
		}
	}
});

site.employees = {
	init: function () {
		$('a', '.linksFilter').each(function (e) {
			var $this = $(this),
				filter = String($this.attr('class'));
			if (filter.indexOf('all') === 0) {
				filter = 'all';
			} else {
				filter = '.' + filter;
			}
			$this.data('filter', filter);
		});
		site.dataFilter.init('.employees .linksFilter', '.employees .items', '#filterSelect', function () {
			setEmployeeHeight();
		});

		site.maxHeight.init('.employee__single .details');

		$('.employee__more').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this),
				$employee = $this.closest('.employee__single');
			$employee.toggleClass('open');
			$employee.siblings().removeClass('open');

			var $iframe = $employee.find('iframe:not([src])');
			if ($iframe.length) {
				$iframe.attr('src', $iframe.data('src'));
			}
		});


		$(window).load(function () {
			setEmployeeHeight()
		});
		let resizeTimer;

		var cachedWidth = $(window).width();
		$(window).on('resize', function () {
			var newWidth = $(window).width();
			if (newWidth !== cachedWidth) {
				if ((cachedWidth > newWidth + 10) || (cachedWidth < newWidth - 10)) {
					$('.employee__single').removeClass('open');
					$('>.wrap', '.employee__single').removeAttr('style');
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(function () {
						setEmployeeHeight();
					}, 250);
				}
			}
		}).resize();

		function setEmployeeHeight() {
			$('.employee__single').each(function () {
				var $this = $(this);
				$this.removeClass('open');
				$('>.wrap', $this)
					.removeAttr('style')
					.css('height', $this[0].scrollHeight);

				if ($this.hasClass('hasDetails')) {
					var $details = $('>.details', $this);
					$details
						.removeAttr('style')
						.css('height', $details[0].scrollHeight);
				}
			});
		}
	}
};

site.eventCarousel = {
	init: function () {
		if ($('.box_calendar_eventlist .eventList .eventsImages .image').length > 1) {
			site.owl.init('.box_calendar_eventlist .eventList .imageWraper', {
				loop: false,
				nav: false,
				dots: false,
				margin: 20,
				items: 1,
				autoplay: false,
				URLhashListener: true,
				startPosition: 'URLHash',
				autoplayHoverPause: true

			});
		}

		$('.box_calendar_eventlist .eventList .event').hover(function () {
			location.hash = $(this).data('hash');

		});

	}
}

site.siteScroll = {
	init: function () {
		// Hide Header on on scroll down
		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;
		var navbarHeight = $('header >.contentWrap').outerHeight();

		$(window).scroll(function (event) {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

		function hasScrolled() {
			var st = $(this).scrollTop();

			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta)
				return;

			// If they scrolled down and are past the navbar, add class .nav-up.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > navbarHeight) {
				// Scroll Down
				$('body').removeClass('nav-down').addClass('nav-up');
			} else {
				// Scroll Up
				if (st + $(window).height() < $(document).height()) {
					$('body').removeClass('nav-up').addClass('nav-down');
				}
			}

			lastScrollTop = st;
		}
	}
};

site.header = {
	init: function () {
		if ($('body').is('.frontpage')) {
			site.sticky.box('body', 'sticky', -95, 320, 992);
		} else {
			site.sticky.box('body', 'sticky', -82, 320, 992);
		}
	}
};

site.songlist = {
	init: function () {
		site.accordion.toggleAll('.accordion__toggleOpen');
	},

	print: function (url) {
		var w = 800,
			h = 600,
			dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left,
			dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top,
			width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
			height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
			left = ((width / 2) - (w / 2)) + dualScreenLeft,
			top = ((height / 2) - (h / 2)) + dualScreenTop;
		window.open(url + '?directprint', '', 'scrollbars=0, toolbar=0,status=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	}
};


// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.labelFocus.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {

		site.eventCarousel.init();
	}
	if ($body.is('.employees')) {
		site.employees.init();
	}
	if ($(window).width() < 992) {
		site.siteScroll.init();
		site.header.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[data-src*="youtube.com"], iframe[data-src*="vimeo.com"]', 'main').each(function () {
		if ($(this).closest('.embed-responsive').length) {
			return;
		}
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	if (window.location.href.indexOf('?directprint') !== -1 && window.opener && window.opener !== window) {
		window.print();
		window.close();
	}
});
